import { useEffect, useMemo, useState } from "react";

export function SearchableDropdown({
  options = [],
  value,
  onChange,
  placeholder = "",
  allowCustom = false,
  style = {},
}) {
  const [query, setQuery] = useState(value || "");
  useEffect(() => {
  setQuery(value || "");
}, [value]);
  const [open, setOpen] = useState(false);

  const filtered = useMemo(() => {
    if (!query) return options;
    return options.filter((opt) =>
      opt.toLowerCase().includes(query.toLowerCase())
    );
  }, [query, options]);

  const handleSelect = (val) => {
    setQuery(val);
    onChange(val);
    setOpen(false);
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        value={query}
        placeholder={placeholder}
        onChange={(e) => {
          setQuery(e.target.value);
          if (allowCustom) onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        style={style}
      />

      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#0b1220",
            border: "1px solid #334155",
            maxHeight: 200,
            overflowY: "auto",
            zIndex: 999,
          }}
        >
          {filtered.length === 0 && allowCustom && (
            <div
              style={{
                padding: 6,
                color: "#94a3b8",
                fontSize: 10,
              }}
            >
              Press enter to use custom value
            </div>
          )}

          {filtered.map((opt) => (
            <div
              key={opt}
              onMouseDown={() => handleSelect(opt)}
              style={{
                padding: "6px 8px",
                cursor: "pointer",
                fontSize: 10,
                color: "#e2e8f0",
              }}
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}